export const SESSION_EXPIRED_EVENT = 'session-expired';

export type SessionExpiredDetail = {
    code?: number;
    message?: string;
};

/** Dialog is open / pending user confirm or countdown � checkAuth must not auto-jump to /login. */
let sessionExpiredPending = false;
let lastEmittedAt = 0;
const EMIT_COOLDOWN_MS = 2000;

export function isSessionExpiredPending(): boolean {
    return sessionExpiredPending;
}

export function clearSessionExpiredPending(): void {
    sessionExpiredPending = false;
}

export function emitSessionExpired(detail?: SessionExpiredDetail): void {
    const now = Date.now();
    if (now - lastEmittedAt < EMIT_COOLDOWN_MS) {
        return;
    }
    lastEmittedAt = now;
    sessionExpiredPending = true;
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail }));
    }
}
